// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Ku8R","title":"Header_title__3r4_6","left":"Header_left__3lGFb","clinicName":"Header_clinicName__aYv-I"};